import React, { useEffect, useState } from 'react'
import { Button } from 'antd-mobile'
import { Route, Switch, Redirect } from 'react-router-dom';
import HomeComponents from '../Home'
// import { UploadOutlined, UserOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { routerViewList, routerFormat, router, routerPathList } from '@/router';



const Home = ({ history = () => { } }: any) => {
    
    return (
        <div style={{ minHeight: "100vh",overflow:'hidden',background:'#ac9e800d' }}>
                {routerViewList().map((item: any) => {
                    const props = item?.props || {}
                    return (
                        <Route
                            path={item.path}
                            exact
                            key={item.path}
                        >
                            <item.component {...props} history={history} />
                        </Route>
                    )
                })}
                {/* <Redirect from={'/todo'} to={'/home'} /> */}
                {/* <Route component={HomeComponents} /> */}
        </div>
    );
}

export default Home;